export default __webpack_public_path__ + "cad2ed29b92c11130a95fd17efc6995d.jpg";